<template>
  <div class="row align-items-center full-height">
    <div class="col full-height angled-11deg">
      <div class="instructions">
        <h2>Confirm User</h2>
        <p>Please enter confirmation code and email address to finish signing up.</p>
      </div>
      <small class="copyright left">iPro<span class="registeredTrademark">&reg;</span> Systems &copy; {{ new Date().getFullYear() }}</small>
    </div>
    <div class="col">
      <form class="login" id="authCon">
        <notification v-show="notification" :notification.sync="notification" class="authModule"></notification>
        <div class="container--login">
          <label for="code">Confirmation Code</label>
          <input type="text" id="code" name="code" v-model="code" />

          <label for="emailconfirm">Confirm Email</label>
          <input type="emailconfirm" id="emailconfirm" name="emailconfirm" v-model="emailconfirm" />
          <router-link tag="a" to="/" class="backtologin"><font-awesome-icon :icon="['fas', 'angle-left']"></font-awesome-icon> Back to Sign In</router-link>
          <button @click.prevent="confirm()" type="submit">Confirm</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import notification from '../notification'
import { notificationTrigger } from '../../mixins/notification.js'

export default {
  name: 'login',
  data () {
    return {
      iconReturn: {
        password: ['far', 'eye-slash'],
        confirm_password: ['far', 'eye-slash']
      },
      siteList: [],
      siteName: '',
      user: false,
      email: '',
      password: '',
      confirm_password: '',
      firstName: '',
      lastName: '',
      code: '',
      emailconfirm: ''
    }
  },
  mixins: [notificationTrigger],
  components: {
    'notification': notification
  },
  created () {
    if (this.$route.params.username) {
      this.emailconfirm = this.$route.params.username
    }
  },
  mounted () {
  },
  methods: {
    showPassword (id) {
      let inputType = document.querySelector('#' + id).type
      if (inputType === 'password') {
        document.querySelector('#' + id).type = 'text'
        this.iconReturn[id] = ['far', 'eye']
      } else {
        document.querySelector('#' + id).type = 'password'
        this.iconReturn[id] = ['far', 'eye-slash']
      }
    },
    validateFields () {
      if (this.confirm_password === this.password && this.firstName && this.lastName) {
        this.savingAnimation('reset', [])
        return true
      }
      let errors = []
      if (this.confirm_password !== this.password) errors.push('Passwords do not match.')
      if (!this.firstName) errors.push('First Name Required.')
      if (!this.lastName) errors.push('Last Name Required.')

      this.savingAnimation('validate', errors)
      return false
    },
    async signUp () {
      let self = this
      if (await Promise.resolve(this.validateFields())) {
        Auth.signUp({
          username: this.email,
          password: this.password,
          attributes: {
            email: this.email,
            given_name: this.firstName,
            family_name: this.lastName
          },
          validationData: []
        })
          .then(data => {
            this.user = true
            this.notification = false
          })
          .catch(err => {
            if (err.code === 'InvalidParameterException' && err.message === 'Invalid email address format.') {
              this.savingAnimation('validate', [err.message])
              this.containerHeight()
            } else if (err.code === 'InvalidPasswordException') {
              self.savingAnimation('validate', [err.message])
            } else if (err.code === 'InvalidParameterException') {
              self.savingAnimation('validate', ['Password did not conform with policy: Password must be 8 characters long and contain at least 1 uppercase letter, 1 lowercase letter, a special charcter and a number'])
            } else if (this.email === '') {
              self.savingAnimation('validate', ['Email cannot be empty. Please enter your email to sign up for an account.'])
              self.containerHeight()
            } else {
              this.savingAnimation('validate', [err])
              this.containerHeight()
            }
          })
      }
    },
    confirm () {
      Auth.confirmSignUp(this.emailconfirm, this.code, {
        forceAliasCreation: true
      }).then(data => {
        this.$router.push('/')
      })
        .catch(err => {
          if (this.emailconfirm === '') {
            this.savingAnimation('validate', ['Email cannot be empty. Please enter your email to sign up for an account.'])
            this.containerHeight()
          } else if (err.code === 'UserNotFoundException') {
            this.savingAnimation('validate', ['Email/confirmation code combination not found. Please try again'])
            this.containerHeight()
          } else {
            this.savingAnimation('validate', [err])
            this.containerHeight()
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../less/elements/color.less';
@import '../../less/utils/mixins.less';
@import '../../less/components/auth.less';
.authModule {
  max-width: 350px;
  position: absolute;
  top: -110px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/confirmUser.vue